module.exports = __webpack_public_path__ + "img/Picture2.fcb35a20.png";